module.exports = __webpack_public_path__ + "static/chris-grant-2-bb6a88cfd96f4e02e6ac82473f576ab1.png";